import { $api } from "../AxiosInstance";

export class SeoService {
  static async getSeoByLocale(params) {
    return await $api.get("/api/admin/siteSeo/allByProxyType/groupByLocale", {
      params,
    });
  }

  static async getSeoById(id) {
    return await $api.get("/api/admin/siteSeo/byId", { params: { id } });
  }

  static async saveSeo(params) {
    return await $api.post("/api/admin/siteSeo", params);
  }

  static async addSeo(params) {
    return await $api.put("/api/admin/siteSeo", params);
  }

  static async deleteSeo(id) {
    return await $api.delete("/api/admin/siteSeo", { params: { id } });
  }
}
